
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ const $a5fd07fa01589658$var$table = document.querySelector(".game-field");
const $a5fd07fa01589658$var$tBody = $a5fd07fa01589658$var$table.querySelector("tbody");
const $a5fd07fa01589658$var$rows = $a5fd07fa01589658$var$tBody.querySelectorAll("tr");
const $a5fd07fa01589658$var$startButton = document.querySelector(".start");
const $a5fd07fa01589658$var$gameScore = document.querySelector(".game-score");
const $a5fd07fa01589658$var$restartButton = document.querySelector(".restart");
const $a5fd07fa01589658$var$startMessage = document.querySelector(".message-start");
const $a5fd07fa01589658$var$loseMessage = document.querySelector(".message-lose");
const $a5fd07fa01589658$var$winMessage = document.querySelector(".message-win");
class $a5fd07fa01589658$var$Game {
    constructor(initialState = []){
        this.state = initialState;
        this.score = 0;
        this.status = "start";
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    getState() {
        return this.state;
    }
    getStatus() {
        return this.status;
    }
    getScore() {
        $a5fd07fa01589658$var$gameScore.textContent = this.score;
        return this.score;
    }
    resetBoard() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++)this.state[i][j] = 0;
        this.score = 0;
    }
    start() {
        this.status = "inProcess";
        this.resetBoard();
        this.spawnCell();
        this.spawnCell();
        this.changeBoard();
        document.removeEventListener("keydown", this.handleKeyPress);
        document.addEventListener("keydown", this.handleKeyPress);
        $a5fd07fa01589658$var$startButton.className = "button restart";
        $a5fd07fa01589658$var$startButton.textContent = "Restart";
        $a5fd07fa01589658$var$startMessage.remove();
        $a5fd07fa01589658$var$winMessage.className = "message message-win hidden";
        $a5fd07fa01589658$var$loseMessage.className = "message message-min hidden";
    }
    restart() {
        $a5fd07fa01589658$var$restartButton.removeEventListener("click", this.handleRestart);
        this.handleRestart = ()=>{
            this.resetBoard();
            this.status = "start";
            $a5fd07fa01589658$var$winMessage.classList.add("hidden");
            $a5fd07fa01589658$var$loseMessage.classList.add("hidden");
            this.start();
        };
        $a5fd07fa01589658$var$restartButton.addEventListener("click", this.handleRestart);
    }
    isGameWin() {
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.state[i][j] === 2048) {
                this.status = "win";
                $a5fd07fa01589658$var$winMessage.className = "message message-win";
            }
        }
    }
    isGameOver() {
        let ansver = true;
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.state[i][j] === 0) ansver = false;
            if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) ansver = false;
        }
        if (ansver === true) {
            this.status = "lose";
            $a5fd07fa01589658$var$loseMessage.className = "message message-lose";
        }
    }
    handleKeyPress(e) {
        if (this.status === "inProcess") switch(e.key){
            case "ArrowUp":
                this.moveUp();
                break;
            case "ArrowDown":
                this.moveDown();
                break;
            case "ArrowLeft":
                this.moveLeft();
                break;
            case "ArrowRight":
                this.moveRight();
                break;
        }
    }
    moveDown() {
        const previousState = JSON.stringify(this.state);
        const newState = [
            0,
            1,
            2,
            3
        ].map((col)=>{
            const column = this.state.map((row)=>row[col]).filter((cell)=>cell !== 0);
            for(let i = column.length - 1; i > 0; i--)if (column[i] === column[i - 1]) {
                column[i] *= 2;
                column[i - 1] = 0;
                this.score += column[i];
            }
            const compressed = column.filter((cell)=>cell !== 0);
            return [
                ...Array(4 - compressed.length).fill(0),
                ...compressed
            ];
        });
        this.state = [
            0,
            1,
            2,
            3
        ].map((row)=>newState.map((col)=>col[row]));
        if (JSON.stringify(this.state) !== previousState) this.spawnCell();
        this.changeBoard();
        this.isGameWin();
        this.isGameOver();
        this.getScore();
    }
    moveLeft() {
        const previousState = JSON.stringify(this.state);
        const newState = this.state.map((row)=>{
            const filtered = row.filter((cell)=>cell !== 0);
            for(let i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                filtered[i] *= 2;
                filtered[i + 1] = 0;
                this.score += filtered[i];
            }
            const compressed = filtered.filter((cell)=>cell !== 0);
            return [
                ...compressed,
                ...Array(4 - compressed.length).fill(0)
            ];
        });
        this.state = newState;
        if (JSON.stringify(this.state) !== previousState) this.spawnCell();
        this.changeBoard();
        this.isGameWin();
        this.isGameOver();
        this.getScore();
    }
    moveRight() {
        const previousState = JSON.stringify(this.state);
        const newState = this.state.map((row, rowIndex)=>{
            const reversed = [
                ...row
            ].reverse();
            const filtered = reversed.filter((cell)=>cell !== 0);
            const merged = Array(4).fill(false);
            for(let i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1] && !merged[i] && !merged[i + 1]) {
                filtered[i] *= 2;
                filtered[i + 1] = 0;
                merged[i] = true;
                this.score += filtered[i];
            }
            const compressed = filtered.filter((cell)=>cell !== 0);
            const result = [
                ...compressed,
                ...Array(4 - compressed.length).fill(0)
            ].reverse();
            return result;
        });
        this.state = newState;
        if (JSON.stringify(this.state) !== previousState) this.spawnCell();
        this.changeBoard();
        this.isGameWin();
        this.isGameOver();
        this.getScore();
    }
    moveUp() {
        const previousState = JSON.stringify(this.state);
        const newState = [
            0,
            1,
            2,
            3
        ].map((col)=>{
            const column = this.state.map((row)=>row[col]).filter((cell)=>cell !== 0);
            for(let i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                column[i] *= 2;
                column[i + 1] = 0;
                this.score += column[i];
            }
            const compressed = column.filter((cell)=>cell !== 0);
            return [
                ...compressed,
                ...Array(4 - compressed.length).fill(0)
            ];
        });
        this.state = [
            0,
            1,
            2,
            3
        ].map((row)=>newState.map((col)=>col[row]));
        if (JSON.stringify(this.state) !== previousState) this.spawnCell();
        this.changeBoard();
        this.isGameWin();
        this.isGameOver();
        this.getScore();
    }
    spawnCell() {
        const nullCells = [];
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.state[i][j] === 0) nullCells.push({
                x: i,
                y: j
            });
        }
        if (nullCells.length !== 0) {
            const randomCell = Math.floor(Math.random() * nullCells.length);
            const { x: x, y: y } = nullCells[randomCell];
            this.state[x][y] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    changeBoard() {
        for(let row = 0; row < $a5fd07fa01589658$var$rows.length; row++){
            const rowCells = $a5fd07fa01589658$var$rows[row].querySelectorAll("td");
            for(let i = 0; i < rowCells.length; i++){
                const value = this.state[row][i];
                if (value !== 0) {
                    rowCells[i].textContent = value;
                    rowCells[i].className = `field-cell field-cell--${value}`;
                } else {
                    rowCells[i].textContent = "";
                    rowCells[i].className = "field-cell";
                }
            }
        }
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


"use strict";
const $09e991522ca7e64e$var$board = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
document.addEventListener("DOMContentLoaded", ()=>{
    const game = new (0, (/*@__PURE__*/$parcel$interopDefault($a5fd07fa01589658$exports)))($09e991522ca7e64e$var$board);
    const startButton = document.querySelector(".start");
    startButton.addEventListener("click", ()=>{
        game.start();
    });
});


//# sourceMappingURL=index.3d403cd4.js.map
